import {
    NinchatProperties,
    NinchatState,
    NinchatStore,
} from '../types'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatUserFoundEvent} from '../types/events'
import {extractProperties} from './'

export const userFound: CaseReducer<NinchatState> = (state, action) => {
    const {
        audience_metadata,
        dialogue_members,
        dialogue_status,
        message_time,
        user_channels,
        user_queues,
        user_realms,
        user_id,
        ...properties
    } = extractProperties<NinchatUserFoundEvent>(action.payload)

    const _user_channels: NinchatStore.NinchatUserChannelsStore = {}
    for (const channel_id of Object.keys(user_channels ?? {})) {
        _user_channels[channel_id] = {
            ...state.user_channels[channel_id],
            ...user_channels?.[channel_id],
        }
    }

    const _user_queues: NinchatProperties.NinchatUserQueues = {...state.user_queues}
    for (const queue_id of Object.keys(user_queues ?? {})) {
        _user_queues[queue_id] = {
            queue_attrs: {},
            queue_settings: {},
            ...user_queues?.[queue_id],
            ...state.user_queues?.[queue_id],
        }
    }

    const _user_realms = Object.entries(user_realms ?? {}).reduce((a: NinchatProperties.NinchatUserRealms, [realm_id, realm_attrs]) => {
        if (state.user_realms[realm_id]?._describe !== 'fulfilled') {
            a[realm_id] = {realm_attrs} as NinchatProperties.NinchatUserRealm
        }
        return a
    }, {})

    if (user_id === state.user_id) {
        return {
            ...state,
            ...properties,
            user_channels: _user_channels,
            user_dialogues: {
                ...state.user_dialogues,
                [user_id]: {
                    ...state.user_dialogues[user_id],
                    audience_metadata,
                    dialogue_members,
                    dialogue_status,
                    message_time,
                },
            },
            user_queues: _user_queues,
            user_realms: {
                ...state.user_realms,
                ..._user_realms,
            },
        }
    }

    return {
        ...state,
        _users: {
            ...state._users,
            [user_id]: {
                ...state._users[user_id],
                ...properties,
            },
        },
    }
}
